<template>
  <div id="app">
	  <meta name="referrer" content="no-referrer">
    <!-- <home v-if="isMobile == 'pc'"></home> -->
    <!-- <home></home> -->
    
    <div class="home-container" :style="{transform: screenWidth>1000?('scale(' + screenWidth / 1000 + ')'):'',width: screenWidth>1000?'':'100%'}">
      <Header :class="screenWidth<=540?'header-fixed':''" v-if="isMobile=='pc'"></Header>
      <Headers v-if="isMobile=='mobile'"></Headers>
      <div :class="screenWidth<=540?'home-main':''">
        <router-view :key="$route.fullPath"></router-view>
        <Footer></Footer>
      </div>
      
    </div>
    
    <!-- <Mobile-Home v-if="isMobile == 'mobile'"></Mobile-Home> -->
  </div>
</template>

<script>
import Home from './views/home/Home.vue'
import MobileHome from './views/home/MobileHome.vue'
import Header from '@/components/header/Header.vue'
import Headers from '@/components/header/Headers.vue'
import Footer from '@/components/footer/Footer.vue'
import { mapMutations } from 'vuex'
export default {
  name: 'app',
  components: {
    Home,
    MobileHome,
    Header,
    Headers,
    Footer
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
    }
  },
  computed: {
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = document.body.clientWidth;
    });
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.WidthTimer) {
          this.screenWidth = newVal;
          this.WidthTimer = true;
          let _this = this;
          setTimeout(() => {
            //在这里做有关浏览器变化时需要做的操作
            _this.WidthTimer = false;
            this.updateScreenWidth(this.screenWidth)
          }, 400);
        }
        // if(newVal)
      }
    }
  },
  methods: {
    ...mapMutations([
      'updateScreenWidth',
    ]),
  },
}
</script>

<style>
.btn-more {
  font-size: 0.8rem;
  width: 6rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  background: #aa221d;
  border-radius: 1rem;
  color: white;
  cursor: pointer;
}
.news-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navigation-title {
  margin-left: 10%;
  padding-top: 2rem;
  font-size: 0.9rem;
}

.text-max-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.text-max-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.text-max-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.text-max-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.text-max-7 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}
img {
  vertical-align: middle;
  object-fit: cover;
}
.home-card-height {
  height: 23rem;
}
.item-div {
  height: 19rem;
}
.home-container {
  width: 1000px;
  transform-origin: top left;
  margin: 0 0;
  font-family: Microsoft YaHei UI;
}

.home-main {
  margin-top: 5rem;
}
.header-fixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}
</style>
